import React from "react";
import { LoadingAnimation } from "@texada/ui";
import "./LoadingScreen.scss";

interface LoadingScreenProps {
  isLoading: boolean;
  refresh?: boolean;
  fullScreen?: boolean;
  isCollapse?: boolean;
  isCardLoading?: boolean;
}

export const LoadingScreen = ({
  isLoading,
  refresh = false,
  fullScreen,
  isCollapse,
  isCardLoading
}: LoadingScreenProps) => {
  if (isLoading && refresh === false) {
    return (
      <div
        className={`loading_screen ${fullScreen ? "fullScreen" : ""} ${
          isCollapse ? "collapsed " : ""
        } ${isCardLoading ? "rental-loading" : ""}`}
      >
        <LoadingAnimation delay={1000} />
      </div>
    );
  }
  return <></>;
};

export default LoadingScreen;
